/**
 * service request menu status enum
 */
export enum ServiceRequestMenuStatusEnum {
  EN_ROUTE = 'en_route',
  NOT_STARTED = 'not_started',
  COMPLETED = 'completed',
  PENDING = 'pending',
}
